import { render, staticRenderFns } from "./ticket_create.vue?vue&type=template&id=7b22ec33"
import script from "./ticket_create.vue?vue&type=script&lang=js"
export * from "./ticket_create.vue?vue&type=script&lang=js"
import style0 from "./ticket_create.vue?vue&type=style&index=0&id=7b22ec33&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports